import { configureStore } from "@reduxjs/toolkit";
import { createBrowserHistory } from "history";

import { createReduxHistoryContext } from "redux-first-history";

import { advantageApi } from "@/api/getAdvantageCard";
import { getDrugApi } from "@/api/getDrug";
import { getPharmacyApi } from "@/api/getPharmacy";

// @ts-ignore
const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({ history: createBrowserHistory() });

const preloadedState = {};
const middleware = [routerMiddleware, advantageApi.middleware, getDrugApi.middleware, getPharmacyApi.middleware];

const rootReducer = {
  router:routerReducer,
  [advantageApi.reducerPath]: advantageApi.reducer,
  [getDrugApi.reducerPath]: getDrugApi.reducer,
  [getPharmacyApi.reducerPath]: getPharmacyApi.reducer,
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
  devTools: process.env.NODE_ENV !== "production",
  preloadedState,
});

export const history = createReduxHistory(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
